'use strict';

function introRouting($stateProvider) {

    let introBaseState = 'root.in-out-neither';

    $stateProvider

    /**
     * WITHOUT END-POINT Section - In-out-neither
     */
        .state('' + introBaseState + '', {
            abstract: true,
            url: "/the-basics",
            views: {
                '': {
                    template: '<ui-view id="basics-section-intro-ui-view"/>',
                },
                'sidebar@root': {
                    template: '<nav class="navbar-default navbar-static-side" role="navigation"><section-in-out-neither-just-browsing-side-menu></section-in-out-neither-just-browsing-side-menu></nav>'
                }
            },
            resolve: {
                loadSectionSpecific: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('./basics.section-specific.js');
                            $ocLazyLoad.load({name: module.name});
                            resolve(module);
                        })
                    });
                },
                loadClerkLedgerDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable")
                    });
                },
            },
            data: {
                baseState: introBaseState,
                sectionName: 'In-out-neither',
                requiresLogin: true,
                pageTitle: 'In-out-neither',
                showSideMenu: true
            }
        })

        .state('' + introBaseState + '.overview', {
            url: "/overview",
            template: require("./just-browsing/overview.html"),
        });

};

function routing($stateProvider) {

    let baseState = 'root.api-endpoints.existing.in-out-neither';

    $stateProvider

    /**
     * Section - In-out-neither
     */
        .state('' + baseState + '', {
            abstract: true,
            url: "/the-basics",
            views: {
                '': {
                    template: '<ui-view id="basics-section-ui-view"/>',
                },
                'sidebar@root': {
                    template: '<nav class="navbar-default navbar-static-side" role="navigation"><section-in-out-neither-just-browsing-side-menu></section-in-out-neither-just-browsing-side-menu></nav>'
                }
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    routeBasedVisibilitySettings.ClerkSupportingDocument_columns_by_step = 'supporting-documents.relevance';
                    routeBasedVisibilitySettings.ClerkAccount_columns_by_step = 'simple';
                    routeBasedVisibilitySettings.ClerkFiscalYear_columns_by_step = 'edit-fiscal-year';
                    routeBasedVisibilitySettings.ClerkLedger_columns_by_step = 'attributes';
                    routeBasedVisibilitySettings.ClerkInvoice_columns_by_step = 'attributes';
                    routeBasedVisibilitySettings.ClerkInvoiceRow_columns_by_step = 'default';
                    routeBasedVisibilitySettings.ClerkInvoiceItem_columns_by_step = 'attributes';
                    routeBasedVisibilitySettings.ClerkTravelClaim_columns_by_step = 'attributes';
                },
                loadSectionSpecific: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('./basics.section-specific.js');
                            $ocLazyLoad.load({name: module.name});
                            resolve(module);
                        })
                    });
                },
                loadSqMerchantCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/sq-merchant/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-sq-merchant")
                    });
                },
                loadSqInboxQueryTemplateCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/sq-inbox-query-template/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-sq-inbox-query-template")
                    });
                },
                loadClueCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clue/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clue")
                    });
                },
                loadInputCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/input/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-input")
                    });
                },
                loadInputResultCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/input-result/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-input-result")
                    });
                },
                loadInterpretationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/interpretation/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-interpretation")
                    });
                },
                loadLocationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/location/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-location")
                    });
                },
                loadInboxQueryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/inbox-query/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-inbox-query")
                    });
                },
                loadInboxQueryResponseCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/inbox-query-response/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-inbox-query-response")
                    });
                },
                loadWhereaboutCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/whereabout/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-whereabout")
                    });
                },
                loadIndicatedEntityWhereaboutPresenceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/indicated-entity-whereabout-presence/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-indicated-entity-whereabout-presence")
                    });
                },
                loadImportSessionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/import-session/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-import-session")
                    });
                },
                loadImportSessionManyManyFileCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/import-session-many-many-file/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-import-session-many-many-file")
                    });
                },
                loadClerkAmbitionLevelCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ambition-level/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ambition-level")
                    });
                },
                loadClerkLedgerEntryCategoryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry-category/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry-category")
                    });
                },
                loadClerkPersonalVsBusinessScenarioCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-personal-vs-business-scenario/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-personal-vs-business-scenario")
                    });
                },
                loadClerkCurrencyCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-currency/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-currency")
                    });
                },
                loadClerkInvoiceItemCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-invoice-item/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-invoice-item")
                    });
                },
                loadClerkInvoiceRowCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-invoice-row/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-invoice-row")
                    });
                },
                loadClerkInOutNeitherCategoryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-in-out-neither-category/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-in-out-neither-category")
                    });
                },
                loadClerkFinancialEventCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-financial-event/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-financial-event")
                    });
                },
                loadClerkTaxEntityEmailIdentityCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-email-identity/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-email-identity")
                    });
                },
                loadClerkReportingBasisCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-reporting-basis/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-reporting-basis")
                    });
                },
                loadClerkAccountCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account")
                    });
                },
                loadClerkAccountCategoryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account-category/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account-category")
                    });
                },
                loadClerkTaxEntityTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-type")
                    });
                },
                loadClerkTransactionRowCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-transaction-row/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-transaction-row")
                    });
                },
                loadClerkVatScenarioCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-vat-scenario/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-vat-scenario")
                    });
                },
                loadClerkTravelClaimCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-travel-claim/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-travel-claim")
                    });
                },
                loadClerkTripCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-trip/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-trip")
                    });
                },
                loadClerkSignificantPeriodCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-significant-period/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-significant-period")
                    });
                },
                loadClerkFiscalYearCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-fiscal-year/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-fiscal-year")
                    });
                },
                loadClerkAccountBalanceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account-balance/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account-balance")
                    });
                },
                loadClerkTaxEntityCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity")
                    });
                },
                loadClerkLedgerAccountCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-account/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-account")
                    });
                },
                loadClerkTaxRegionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-region/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-region")
                    });
                },
                loadClerkLedgerAccountBalanceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-account-balance/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-account-balance")
                    });
                },
                loadClerkLedgerEntryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry")
                    });
                },
                loadClerkLedgerEntryRowCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry-row/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry-row")
                    });
                },
                loadClerkLedgerEntryTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry-type")
                    });
                },
                loadClerkInvoiceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-invoice/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-invoice")
                    });
                },
                loadClerkBasisOfAccountingCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-basis-of-accounting/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-basis-of-accounting")
                    });
                },
                loadClerkTransactionTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-transaction-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-transaction-type")
                    });
                },
                loadClerkLedgerCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger")
                    });
                },
                loadClerkDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-deliverable")
                    });
                },
                loadClerkDeliverableArtifactCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-deliverable-artifact/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-deliverable-artifact")
                    });
                },
                loadClerkLedgerDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable")
                    });
                },
                loadClerkLedgerDeliverableArtifactCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable-artifact/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable-artifact")
                    });
                },
                loadClerkTaxEntityRelationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-relation/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-relation")
                    });
                },
                loadClerkTaxEntityRelationTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-relation-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-relation-type")
                    });
                },
                loadClerkSupportingDocumentCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-supporting-document/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-supporting-document")
                    });
                },
                loadClerkSupportingDocumentTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-supporting-document-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-supporting-document-type")
                    });
                },
                loadClerkInputResultMetadataCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-input-result-metadata/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-input-result-metadata")
                    });
                },
                loadAccountCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/account/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-account")
                    });
                },
                loadFileCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/file/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-file")
                    });
                },
                loadFileInstanceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/file-instance/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-file-instance")
                    });
                },
            },
            data: {
                baseState: baseState,
                sectionName: 'In-out-neither',
                importSessionProductScope: 'clerk',
                pageTitle: 'In-out-neither',
                showSideMenu: true
            }
        });

    let updateRouteBasedContentFiltersByClerkLedgerDeliverable = function (routeBasedContentFilters, clerkLedgerDeliverable) {

        routeBasedContentFilters.ClerkInvoice_sent_from_or_to_party_clerk_tax_entity_id_or_empty = clerkLedgerDeliverable.filter_relevant_clerk_tax_entity_id;
        routeBasedContentFilters.ClerkInvoice_relevant_to_period_start_date_or_empty = clerkLedgerDeliverable.filter_relevant_from_date;
        routeBasedContentFilters.ClerkInvoice_relevant_to_period_end_date_or_empty = clerkLedgerDeliverable.filter_relevant_to_date;
        routeBasedContentFilters.ClerkInvoiceRow_ClerkInvoice_sent_from_or_to_party_clerk_tax_entity_id_or_empty = clerkLedgerDeliverable.filter_relevant_clerk_tax_entity_id;
        routeBasedContentFilters.ClerkInvoiceRow_ClerkInvoice_relevant_to_period_start_date_or_empty = clerkLedgerDeliverable.filter_relevant_from_date;
        routeBasedContentFilters.ClerkInvoiceRow_ClerkInvoice_relevant_to_period_end_date_or_empty = clerkLedgerDeliverable.filter_relevant_to_date;

        //routeBasedContentFilters.ClerkTransactionRow_ledger_relevant_for_clerk_tax_entity_id = clerkLedgerDeliverable.filter_relevant_clerk_tax_entity_id; // Don't define here or corresponding filter won't work
        routeBasedContentFilters.ClerkTransactionRow_from_date = clerkLedgerDeliverable.filter_relevant_from_date;
        routeBasedContentFilters.ClerkTransactionRow_to_date = clerkLedgerDeliverable.filter_relevant_to_date;

        //routeBasedContentFilters.ClerkLedgerAccount_clerk_tax_entity_id = clerkLedgerDeliverable.filter_relevant_clerk_tax_entity_id;
        //routeBasedContentFilters.ClerkLedgerEntry_clerk_tax_entity_id = clerkLedgerDeliverable.filter_relevant_clerk_tax_entity_id;

    };

    let loadClerkLedgerDeliverableByClerkLedgerDeliverableIdParam = function (clerkLedgerDeliverable, clerkLedgerDeliverableId) {

        if (clerkLedgerDeliverableId) {
            clerkLedgerDeliverable.$activate();
            return clerkLedgerDeliverable.load(clerkLedgerDeliverableId);
        } else {
            return clerkLedgerDeliverable.load(null);
        }

    };

    let updateRouteBasedContentFiltersBasedOnTransactionsCurateStep = function (routeBasedContentFilters, curateStep, $state, $rootScope, $timeout) {

        switch (curateStep) {
            case "up-to-date-and-complete":
                routeBasedContentFilters.ClerkTransactionRow_hide_split_parents = '0';
                routeBasedContentFilters.ClerkTransactionRow_hide_split_children = '1';
                break;
            default:
                routeBasedContentFilters.ClerkTransactionRow_hide_split_parents = '1';
                routeBasedContentFilters.ClerkTransactionRow_hide_split_children = '0';
                break;
        }

        switch (curateStep) {
            case "up-to-date-and-complete":
                routeBasedContentFilters.ClerkTransactionRow_order = 'ClerkTransactionRow.date_settled IS NULL ASC, ClerkTransactionRow.date_settled DESC, ClerkTransactionRow.raw_info_weight ASC, ClerkTransactionRow.amount ASC, ClerkTransactionRow.raw_info_date DESC';
                break;
            case "supporting-documents":
                routeBasedContentFilters.ClerkTransactionRow_order = 'ClerkTransactionRow_abs_amount DESC, ClerkTransactionRow.date_settled IS NULL ASC, ClerkTransactionRow.date_settled DESC, ClerkTransactionRow.raw_info_weight ASC, ClerkTransactionRow.raw_info_date DESC';
                break;
            default:
            case "assign-sending-and-receiving-parties-one-by-one":
            case "ledger-entry-types-one-by-one":
            case "expense-report-contents":
            case "map-invoice-related-transactions":
                routeBasedContentFilters.ClerkTransactionRow_order = 'ClerkTransactionRow.date_settled IS NULL ASC, ClerkTransactionRow.date_settled ASC, ClerkTransactionRow.raw_info_weight DESC, ClerkTransactionRow.amount ASC, ClerkTransactionRow.raw_info_date ASC';
                break;
        }

        // Invoice-related transactions are handled by their invoice metadata and should
        // not be displayed in the other steps in order to avoid confusion
        switch (curateStep) {
            case "fine-tune-ledger-accounts":
            case "supporting-documents":
            case "assign-sending-and-receiving-parties-one-by-one":
            case "assign-sending-and-receiving-parties":
                routeBasedContentFilters.ClerkTransactionRow_is_this_paying_an_invoice = '!1';
                break;
            default:
            case "ledger-entry-types":
            case "ledger-entry-types-one-by-one":
            case "map-invoice-related-transactions":
                routeBasedContentFilters.ClerkTransactionRow_is_this_paying_an_invoice = null;
                break;
        }

        switch (curateStep) {
            default:
            case "assign-sending-and-receiving-parties":
            case "assign-sending-and-receiving-parties-one-by-one":
            case "import":
            case "parse-imported":
            case "reality-check":
            case "up-to-date-and-complete":
            case "whereabouts":
            case "map-invoice-related-transactions":
            case "calculate-vat-amounts":
            case "expense-report-contents":
            case "ledger-entry-types":
            case "ledger-entry-types-one-by-one":
            case "fine-tune-ledger-accounts":
            case "supporting-documents":
                routeBasedContentFilters.ClerkTransactionRow_receiving_or_sending_party_ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                break;
            case "foo":
                // Show only transactions that are being brought up in a company books
                routeBasedContentFilters.ClerkTransactionRow_receiving_or_sending_party_ClerkTaxEntity_ClerkTaxEntityType_ref = '<>person';
                break;
        }

        switch (curateStep) {
            case "assign-sending-and-receiving-parties":
            case "ledger-entry-types":
                routeBasedContentFilters.ClerkTransactionRow_show_only_archetypes = 1;
                break;
            default:
            case "assign-sending-and-receiving-parties-one-by-one":
            case "ledger-entry-types-one-by-one":
            case "calculate-vat-amounts":
            case "expense-report-contents":
            case "import":
            case "parse-imported":
            case "reality-check":
            case "up-to-date-and-complete":
            case "whereabouts":
            case "map-invoice-related-transactions":
            case "fine-tune-ledger-accounts":
            case "supporting-documents":
                routeBasedContentFilters.ClerkTransactionRow_show_only_archetypes = null;
                break;
        }

        // Necessary to make sure that no old filter lags behind when navigating to a new view?
        let stopWatching = $rootScope.$watch(function () {
            return $state.current && $state.current.name;
        }, function () {
            // Wait for $state.current.name to be ready
            if ($state.current.name !== '') {
                let goToStateParams = {
                    'cf_ClerkTransactionRow_order': routeBasedContentFilters.ClerkTransactionRow_order,
                    'cf_ClerkTransactionRow_is_this_paying_an_invoice': routeBasedContentFilters.ClerkTransactionRow_is_this_paying_an_invoice,
                    'cf_ClerkTransactionRow_receiving_or_sending_party_ClerkTaxEntity_ClerkTaxEntityType_ref': routeBasedContentFilters.ClerkTransactionRow_receiving_or_sending_party_ClerkTaxEntity_ClerkTaxEntityType_ref,
                    'cf_ClerkTransactionRow_show_only_archetypes': routeBasedContentFilters.ClerkTransactionRow_show_only_archetypes,
                };
                $timeout(function () {
                    $state.go($state.current.name, goToStateParams);
                });
                stopWatching();
            }
        });

    };

    $stateProvider

        .state('' + baseState + '.optionally-by-clerk-ledger-deliverable', {
            abstract: true,
            url: "/:activeClerkLedgerDeliverableId",
            params: {activeClerkLedgerDeliverableId: {value: 'browsing', dynamic: true}},
            resolve: {
                setRouteBasedContentFiltersBasedOnClerkLedgerDeliverable: /*@ngInject*/ function (setRouteBasedContentFiltersLevel0, routeBasedContentFilters, clerkLedgerDeliverable, $stateParams) {
                    var clerkLedgerDeliverableId = $stateParams.activeClerkLedgerDeliverableId === 'browsing' ? null : $stateParams.activeClerkLedgerDeliverableId;
                    loadClerkLedgerDeliverableByClerkLedgerDeliverableIdParam(clerkLedgerDeliverable, clerkLedgerDeliverableId).then(
                        function (loadedClerkLedgerDeliverable) {
                            updateRouteBasedContentFiltersByClerkLedgerDeliverable(routeBasedContentFilters, loadedClerkLedgerDeliverable);
                        }
                    );
                    return true;
                },
                setRouteBasedContentFiltersBasedOnTransactionsCurateStep: /*@ngInject*/ function (setRouteBasedContentFiltersBasedOnClerkLedgerDeliverable, routeBasedContentFilters, $stateParams, $state, $rootScope, $timeout) {
                    if ($stateParams.curateStep) {
                        updateRouteBasedContentFiltersBasedOnTransactionsCurateStep(routeBasedContentFilters, $stateParams.curateStep, $state, $rootScope, $timeout);
                    }
                    return true;
                },
                setRouteBasedContentFiltersLevel1A: /*@ngInject*/ function (setRouteBasedContentFiltersBasedOnTransactionsCurateStep, routeBasedContentFilters, $stateParams) {
                    routeBasedContentFilters.ImportSession_product_scope = 'clerk';
                    routeBasedContentFilters.ClerkDeliverable_section_scope = 'in-out-neither';
                    routeBasedContentFilters.ClerkDeliverable_order = 'ordinal ASC';
                    routeBasedContentFilters.ClerkLedgerDeliverable_ClerkDeliverable_section_scope = 'in-out-neither';
                    routeBasedContentFilters.ClerkLedgerDeliverable_order = 'to_be_reported_to_authorities_by_utc_datetime ASC, order_of_production ASC';
                    routeBasedContentFilters.ClerkLedgerEntryCategory_order = 'ordinal ASC';
                    routeBasedContentFilters.ClerkLedgerEntryType_order = 'relevant_clerk_ledger_entry_category_id ASC';
                    routeBasedContentFilters.ClerkAccount_order = 'clerk_tax_entity_id ASC, label ASC, id ASC';

                    routeBasedContentFilters.ClerkFiscalYear_ClerkTaxEntity_knowledge_of_internals_expected = '1';
                    routeBasedContentFilters.ClerkLedger_ClerkTaxEntity_knowledge_of_internals_expected = '1';
                    //routeBasedContentFilters.ClerkTaxEntity_knowledge_of_internals_expected = '1'; Do not restrict on tax entity level since we need to be able to assign tax entities for our companies that use our personal wallet
                    routeBasedContentFilters.ClerkSignificantPeriod_RelevantClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_knowledge_of_internals_expected = '1';
                    routeBasedContentFilters.ClerkTransactionRow_FromOrToClerkAccount_ClerkTaxEntity_ClerkTaxEntityType_ref = null; // Do not restrict on ctr level - Wallet should represent all transactions that pass through the person's Wallet, including company credit cards
                    //routeBasedContentFilters.ClerkTransactionRow_receiving_or_sending_party_ClerkTaxEntity_ClerkTaxEntityType_ref = null; // Set further down
                    routeBasedContentFilters.ClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_ref = 'person';
                    routeBasedContentFilters.ClerkLedger_ClerkTaxEntity_ClerkTaxEntityType_ref = 'person';
                    routeBasedContentFilters.ClerkTaxEntity_ClerkTaxEntityType_ref = null; // Do not restrict on tax entity level since we need to be able to assign tax entities for our companies that use our personal wallet
                    routeBasedContentFilters.ClerkSignificantPeriod_RelevantClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_ref = 'person';

                    /*
                     // Make these reset to empty by default in this section unless otherwise specified
                     routeBasedContentFilters.ClerkFiscalYear_ClerkTaxEntity_knowledge_of_internals_expected = null;
                     routeBasedContentFilters.ClerkLedger_ClerkTaxEntity_knowledge_of_internals_expected = null;
                     routeBasedContentFilters.ClerkTaxEntity_knowledge_of_internals_expected = null;
                     routeBasedContentFilters.ClerkSignificantPeriod_RelevantClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_knowledge_of_internals_expected = null;
                     routeBasedContentFilters.ClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                     routeBasedContentFilters.ClerkLedger_ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                     routeBasedContentFilters.ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                     routeBasedContentFilters.ClerkSignificantPeriod_RelevantClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                     */

                    return true;
                },
                currentClerkLedgerDeliverable: /*@ngInject*/ function (dataEnvironmentParam, $stateParams, clerkLedgerDeliverable) {
                    console.log('optionally-by-clerk-ledger-deliverable - currentClerkLedgerDeliverable', $stateParams);
                    let clerkLedgerDeliverableId = $stateParams.activeClerkLedgerDeliverableId === 'browsing' ? null : $stateParams.activeClerkLedgerDeliverableId;
                    return loadClerkLedgerDeliverableByClerkLedgerDeliverableIdParam(clerkLedgerDeliverable, clerkLedgerDeliverableId);
                },
            },
            views: {
                '': {
                    template: '<ui-view id="basics-section-obcld-ui-view"/>',
                    controller: /*@ngInject*/ function (routeBasedContentFilters, $scope, clerkLedgerDeliverable, $state, $rootScope, $timeout) {

                        this.uiOnParamsChanged = function (changedParams, $transition$) {
                            console.log('optionally-by-clerk-ledger-deliverable - routes.uiOnParamsChanged', changedParams, $transition$);
                            if (changedParams.activeClerkLedgerDeliverableId) {
                                var clerkLedgerDeliverableId = changedParams.activeClerkLedgerDeliverableId === 'browsing' ? null : changedParams.activeClerkLedgerDeliverableId;
                                loadClerkLedgerDeliverableByClerkLedgerDeliverableIdParam(clerkLedgerDeliverable, clerkLedgerDeliverableId).then(
                                    function (loadedClerkLedgerDeliverable) {
                                        updateRouteBasedContentFiltersByClerkLedgerDeliverable(routeBasedContentFilters, loadedClerkLedgerDeliverable);
                                    }
                                );
                            }
                            if (changedParams.curateStep) {
                                updateRouteBasedContentFiltersBasedOnTransactionsCurateStep(routeBasedContentFilters, changedParams.curateStep, $state, $rootScope, $timeout);
                            }
                        };
                    },
                },
            },
            onExit: /*@ngInject*/ function (routeBasedContentFilters, clerkLedgerDeliverable) {
                let clerkLedgerDeliverableId = null;
                loadClerkLedgerDeliverableByClerkLedgerDeliverableIdParam(clerkLedgerDeliverable, clerkLedgerDeliverableId).then(
                    function (unloadedClerkLedgerDeliverable) {
                        updateRouteBasedContentFiltersByClerkLedgerDeliverable(routeBasedContentFilters, unloadedClerkLedgerDeliverable);
                    }
                );
                return true;
            },
        });

    // just-browsing
    let justBrowsingSubsection = require('./just-browsing/routes.js');
    justBrowsingSubsection.routes($stateProvider, '' + baseState + '.optionally-by-clerk-ledger-deliverable.just-browsing');

    // personal-vs-business-expenses
    let pvbeSubsection = require('./personal-vs-business-expenses/routes.js');
    pvbeSubsection.loadRoutesLazily($stateProvider, '' + baseState + '.optionally-by-clerk-ledger-deliverable.personal-vs-business-expenses');

    // personal-financial-situation-insights
    let pfsiSubsection = require('./personal-financial-situation-insights/routes.js');
    pfsiSubsection.loadRoutesLazily($stateProvider, '' + baseState + '.optionally-by-clerk-ledger-deliverable.personal-financial-situation-insights');

}

export default angular
    .module('in-out-neither.routing', [])
    .config(function ($stateProvider) {

        // Lazy load the states instead of loading them all at app bootstrap

        /*
         let lazyIntroStateProvider = {
         states: [],
         state: function (name, stateConfig) {
         let state = angular.merge({name: name}, stateConfig);
         this.states.push(state);
         return this;
         }
         };
         introRouting(lazyIntroStateProvider);
         $stateProvider.state('root.in-out-neither.**', {
         url: "/the-basics",
         lazyLoad: function ($transition$, ParentService) {
         return lazyIntroStateProvider;
         },
         });
         */
        // Eager-loading intro-states since there are issues with those routes and since they are so few, it is ok to load them eagerly for now
        introRouting($stateProvider);

        let lazyStateProvider = {
            states: [],
            state: function (name, stateConfig) {
                let state = angular.merge({name: name}, stateConfig);
                this.states.push(state);
                return this;
            }
        };
        routing(lazyStateProvider);
        $stateProvider.state('root.api-endpoints.existing.in-out-neither.**', {
            url: "/the-basics",
            lazyLoad: function ($transition$, ParentService) {
                return lazyStateProvider;
            },
        });

    });



// WEBPACK FOOTER //
// .-dna/app/sections/3-basics/basics.routing.js